import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

const EditSchoolPricing = () => {
  const [schoolClassName, setSchoolClassName] = useState([]);
  const [classId, setClassId] = useState();
  const [price, setPrice] = useState();
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const { id } = useParams();

  const getClasses = () => {
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        const { data } = resp.data;
        setSchoolClassName(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getClasses();
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/pricing/exam-notes/${id}`)
      .then((result) => {
        console.log(result);
        const data = result?.data?.data;
        setClassId(data?.classId?._id);
        setPrice(data?.price);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const payload = {
    classId,
    price,
    type: "school",
  };

  const handleAddPrice = () => {
    navigate("/exam-notes-pricing/add-school-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/exam-notes-pricing/all-school-pricing");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${API_BASE_URL}/admin/pricing/exam-notes/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("School Exam Notes Price Updated.");
        navigate("/exam-notes-pricing/all-school-pricing");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while updating price.");
      });
  };
  return (
    <>
      <div id="add-department-inner-wrapper">
        <div className="superheader">
          <div className="departmetHeaderdiv">
            <h5>School Exam Notes Price</h5>
            <div className="departmentdiv2">
              <button className="handlenewclass" onClick={handleAddPrice}>
                + Add Price
              </button>
              <button className="allclasses" onClick={handleViewAllPrice}>
                All Price
              </button>
            </div>
          </div>

          <div className="form-school-container">
            <h4 className="department-detail">Price Update</h4>
            <form onSubmit={handleSubmit} className="department-detail-form">
              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Class Name</label>
                </div>
                <select
                  className="select-dropdown"
                  value={classId}
                  onChange={(e) => setClassId(e.target.value)}
                  required
                >
                  <option value="">-Select Class-</option>
                  {schoolClassName &&
                    schoolClassName.map((classes) => (
                      <option value={classes._id} key={classes._id}>
                        {classes?.className}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group">
                <div style={{ paddingBottom: "10px" }}>
                  <label className="label">Price</label>
                </div>
                <input
                  className="school-class-add-input-tag"
                  type="text"
                  value={price}
                  onChange={(e) => setPrice(e.target.value)}
                  placeholder="Enter Price"
                  required
                />
              </div>

              <div className="form-school-btns">
                <button className="btn-s" type="save">
                  Save
                </button>
                <button className="btn-c" type="cancel">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSchoolPricing;
